(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("VidiunPlayer", [], factory);
	else if(typeof exports === 'object')
		exports["VidiunPlayer"] = factory();
	else
		root["VidiunPlayer"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition